import * as React from "react";
import { connect } from "react-redux";
import Iframe from 'react-iframe';
import { withRouter, Prompt } from 'react-router';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import Cookies from "cookies-js";
import { getDomain } from "../../helpers/Tools";
import ReactIframeResizer from "../common/iFrameResizerComponent";
import * as d from "../../reducers/domainReducer";
import { getURLPath } from '../../helpers/Tools';
import { logUI } from '../../api/andyliticsApi';
import Spinner from "../common/spinner";
import { getFirstName, getSecondName } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";
import SectionLoadingError from "../common/SectionLoadingError";


const SURVEY_CANCELLED = "surveycancelled";
const SURVEY_COMPLETED = "surveycompleted";
const COMPLETE = 'complete';

/**
 * Wellness Assessment.
 * 
 */

class WellnessAssessment extends React.Component {
    constructor(props) {
        super(props);
        var _byroute = false;
        this.serverData = this.props.serverData;
        this.processWindowMessage = this.processWindowMessage.bind(this);

    }

    componentDidMount() {
        this._isMounted = true;
        window.formChanged = false;
        window.addEventListener("message", this.processWindowMessage);
        const { thriveData } = this.props;
        let andyliticsJson = {
            surveyUrl: thriveData && thriveData.surveyUrl ? thriveData.surveyUrl : ''
        };
        logUI("MBHWeb.UI.WellnessAssessment.ComponentDidMount", new Date(), getURLPath(), andyliticsJson);
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.formChanged = false;
        window.removeEventListener("message", this.processWindowMessage);
    }

    processWindowMessage(messageEvent) {
        const { token } = this.props;
        if (messageEvent.data && messageEvent.data === SURVEY_CANCELLED) {
            logUI("MBHWeb.UI.WellnessAssessment.Cancelled", new Date(), getURLPath());
            this.props.getThriveData(token);
            this.props.history.push("/dashboard");
        } else if (messageEvent.data && messageEvent.data === SURVEY_COMPLETED) {
            logUI("MBHWeb.UI.WellnessAssessment.Completed", new Date(), getURLPath());
            this.props.getThriveData(token);
            this.props.history.push({ pathname: "/wellnessassessmentsuccess", state: { isComplete: true } });
        }
    }

    render() {

        //debugger;
        const { reloadKey, currentUser, thriveData, thriveDataPending, thriveDataSuccess, thriveDataError, isEmployee } = this.props;
        const sAdditionalScripts = [window.location.origin + '/scripts/childChangeDetection.js'];
        const sAdditionalCSS = [window.location.origin + '/css/wellness.css'];

        //Adding target key param in survey to handle our css.
        const url = thriveData && thriveData.surveyUrl ? thriveData.surveyUrl + '&target=web' : '';

        const isSurveyCompleted = (thriveData && thriveData.surveyStatus && thriveData.surveyStatus.toLowerCase() === COMPLETE) ? true : false;

        //if (!url) {
        //    return <div></div>;
        //}

        var myDomain = getDomain();

        const iframeResizerOptions = { checkOrigin: false, scrolling: true, heightCalculationMethod: 'bodyScroll', warningTimeout: 10000 };
        const iframeResizerStyle = this.props.style || { width: '100%' };
        //debugger;
        const formID = this.props.id ? this.props.id : "wellness_assessment";
        //debugger;
        return (
                (url && !isSurveyCompleted) ?
                    <div className = "mychartDataTile wellnessAssessmentTile">
                        <React.Fragment >
                             <ReactIframeResizer additionalCSS={sAdditionalCSS} additionalScripts={sAdditionalScripts} ref="thisFrame" key={reloadKey} id={formID} title="Well-Being Assessment" iframeResizerOptions={iframeResizerOptions} src={url} style={iframeResizerStyle} />
                         </React.Fragment >
                    </div>
                     :
                  <div className="container-fluid body-content">
                      <div className="row">
                        <div className="col-12 maxWidth-content">
                            {(isEmployee && (thriveDataPending || (!thriveDataSuccess && !thriveDataError))) ? <Spinner /> :
                                isSurveyCompleted ?
                                    <SectionLoadingError message="The assessment has been completed and is not available." sectionErrorClass="not-available-error" titleIcon="icon-log-out" /> :
                                    isEmployee ? <SectionLoadingError message="Sorry, we're not able to load the assessment. Please try again later." /> :
                                        <SectionLoadingError titleIcon="icon-error" sectionErrorClass="feature-error">
                                            To access the wellness assessment please link your employee account <Link to={{ pathname: '/linkedaccounts', searchParams: "openEmployee=true" }}>here</Link>.
                                         </SectionLoadingError>
                                        }
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginStatus: state.domain.ls,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,
        token: state.domain.t,
        reloadKey: state.session.reloadKey,
        empId: state.domain.ei,
        thriveDataPending: state.thrive.cardPending,
        thriveDataSuccess: state.thrive.cardSuccess,
        thriveDataError: state.thrive.error ? true : false,
        thriveData: state.thrive.card,
        isEmployee: state.domain.ie
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getThriveData: (token) => {
            dispatch({ type: types.THRIVE_GET_CARD, token: token });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellnessAssessment));
